import { TouchpointType } from "types/touchpoint";

export function getTouchpointTypeFromMondayChannel(channel?: string | null): TouchpointType {
  if (!channel?.trim()) {
    return TouchpointType.OTHER;
  }

  const normalized = channel.trim().toLowerCase().replace(/[\s-]+/g, "_");

  switch (normalized) {
    case "email":
      return TouchpointType.EMAIL;
    case "webpages":
    case "web_page":
    case "forms":
    case "form":
      return TouchpointType.LANDING_PAGE;
    default:
      return TouchpointType.OTHER;
  }
}
